// extracted by mini-css-extract-plugin
export var card = "_sk-0";
export var details = "_sk-1";